export default "__VITE_ASSET__BGgtLT4g__"